module.exports = __webpack_public_path__ + "static/media/Hover_5_Maryland.06a486cb.png";